.transcriptContainer {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
}

.transcriptWrapper {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
  color: #201f23;
  // Don't set overflow: hidden here as it clips the focus outline.

  > * {
    flex: 0 0 auto;
  }

  .transcriptText {
    flex: 1 1 auto;
    min-height: 0;
  }
}

.hiddenWrapper {
  overflow: hidden;
}

.transcriptText {
  font-size: 16px;
  margin: 0 6px;
  padding: 6px 8px;
  border-radius: 4px;
  min-height: 0;
  background: #fff;
  box-shadow: inset 0px 0px 3px rgb(2 2 2 / 25%);
  overflow-y: auto;
  transform: translateY(0);
  transition: 0.5s ease all;
  flex: 1 1 auto;

  &.isHidden {
    padding: 0;
    overflow: hidden;
    // go down while collapse appears to go up
    transform: translateY(100%);
    height: 0;
  }
}

// We only apply this with the direct embed.
// The iframe instead fills to grow with the UI height on the root div.
// See js-sdk/src/index.ts
.directEmbedTranscriptHeight {
  height: 200px;
}

.iframeTranscriptHeight {
  // confusingly, in the case of an empty transcript we need to give
  // the textarea a height. This will be constrained by the total height of the
  // player. `min-height` will not work, as it won't shrink properly without
  // removing the instrinic constraint.
  height: 2000px;
}

.paragraph {
  line-height: 1.5;
  margin-bottom: 1em;
}
